import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS, buildWhatsAppLink } from "../constants";

export default function Products() {
  return (
    <section
      id="productos"
      data-testid="products-section"
      className="relative py-24 sm:py-32 bg-sand"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14 sm:mb-20">
          <div className="max-w-2xl">
            <div className="label-eyebrow mb-4">Nuestra colección</div>
            <h2
              data-testid="products-title"
              className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[1.05]"
            >
              Prendas que se hacen{" "}
              <span className="italic text-vino">tuyas</span>.
            </h2>
          </div>
          <p className="max-w-md text-base text-[#5C5050]">
            Bodys, jerseys y activewear listos para personalizar con tu nombre o logo. 
            Confección artesanal con mucho amor.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          {PRODUCTS.map((p, idx) => (
            <article
              key={p.id}
              data-testid={`product-card-${p.id}`}
              className="group flex flex-col"
            >
              <div className="img-zoom rounded-[2rem] overflow-hidden aspect-[3/4] mb-5 relative">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-page/90 backdrop-blur-md px-3 py-1.5 text-[10px] uppercase tracking-[0.25em] text-vino font-medium border border-line">
                  0{idx + 1} / Personalizable
                </div>
              </div>

              <div className="flex items-start justify-between gap-4">
                <h3 className="font-heading text-2xl sm:text-3xl text-ink">
                  {p.name}
                </h3>
                {p.id === "bodys" ? (
                  <Link
                    to="/bodys"
                    data-testid={`product-cta-${p.id}`}
                    className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full border border-vino/40 text-vino hover:bg-vino hover:text-page transition-colors"
                    aria-label={`Ver colección ${p.name}`}
                  >
                    <ArrowUpRight size={16} />
                  </Link>
                ) : (
                  <a
                    href={buildWhatsAppLink(`Hola, me interesa el producto: ${p.name}. ¿Me puedes dar más información?`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`product-cta-${p.id}`}
                    className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full border border-vino/40 text-vino hover:bg-vino hover:text-page transition-colors"
                    aria-label={`Cotizar ${p.name}`}
                  >
                    <ArrowUpRight size={16} />
                  </a>
                )}
              </div>

              <p className="mt-3 text-[15px] text-ink-soft leading-relaxed">
                {p.description}
              </p>

              <div className="mt-4 flex flex-wrap gap-2">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11px] uppercase tracking-[0.18em] text-ink-soft border border-line rounded-full px-3 py-1 bg-page"
                  >
                    {t}
                  </span>
                ))}
              </div>

              {p.id === "bodys" && (
                <Link
                  to="/bodys"
                  data-testid="product-bodys-explore-link"
                  className="mt-5 inline-flex items-center gap-2 text-vino font-medium link-underline self-start"
                >
                  Ver los modelos →
                </Link>
              )}
            </article>
          ))}
        </div>

        <div className="mt-16 sm:mt-20 flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-sm text-ink-soft text-center sm:text-left">
            ¿No ves lo que buscas? Diseñamos cualquier prenda a tu medida.
          </p>
          <a
            href={buildWhatsAppLink("Hola, quiero cotizar una prenda especial.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="products-cta-quote"
            className="inline-flex items-center gap-2 rounded-full bg-vino text-page px-6 py-3 text-sm font-medium hover:bg-vino-deep transition-all hover:-translate-y-0.5"
          >
            Solicitar cotización
            <ArrowUpRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
